import { Button, Grid, Typography, TextField, Box, Hidden, Card, CardContent
    , FormControl, InputLabel, Select, IconButton } from "@mui/material";
import { Search as IconSearch, IndeterminateCheckBox as IconIndeterminateCheckBox
    , CheckBox as IconCheckBox, PersonAdd as IconPersonAdd } from "@mui/icons-material";
import * as servicioService from "../../services/servicioService";
import * as filialService from "../../services/filialService";
import * as catalogoService from "../../services/catalogoService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { setData, setResults
    , setListServicios, setListFiliales, setListTipos, setListModalidades, setListEstados } from '../../redux/invoiceItemSearchSlice';
import DialogYesNo from '../../components/DialogYesNo';
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";

const Index = () => {
    const { isReadOnly } = useMantenimiento("conceptoCobro");
    const filters = useSelector((state) => state.invoiceItemSearch.filters);
    const listServicios = useSelector((state) => state.invoiceItemSearch.listServicios);
    const listFiliales = useSelector((state) => state.invoiceItemSearch.listFiliales);
    const listTipos = useSelector((state) => state.invoiceItemSearch.listTipos);
    const listEstados = useSelector((state) => state.invoiceItemSearch.listEstados);
    
    const [openDialogAnnulActive, setOpenDialogAnnulActive] = useState(false)
    const openCloseDialogAnnulActive = () => { setOpenDialogAnnulActive(!openDialogAnnulActive); }
    const [selectId, setSelectId] = useState(null);
    const [selectState, setSelectState] = useState(null);

    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const fetchResults = async () => {
        setCargando(true);

        await servicioService.getsConceptoCobroView(filters)
            .then((data) => {
                setResults(data);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchServicios = async () => {
        const data = await servicioService.getsListServicio()
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });

        dispatch(setListServicios(data));
    }

    const fetchFiliales = async () => {
        const data = await filialService.getFilialesList()
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });

        dispatch(setListFiliales(data));
    }

    const fetchTipos = async () => {
        const data = await catalogoService.getCatalogosByPadre(49)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });

        dispatch(setListTipos(data));
    }
    const fetchEstados = async () => {
        await catalogoService.getCatalogosByPadre(1)
            .then((data) => {
                dispatch(setListEstados(data));
                dispatch(setData({name: "idEstado", value: 2}))
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const annul = async () => {
        await servicioService.annulConceptoCobro(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }
    const active = async () => {
        await servicioService.activeConceptoCobro(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }

    useEffect(() => {
        fetchResults();
        fetchServicios();
        fetchFiliales();
        fetchTipos();
        fetchEstados();
    }, []);

    const columns = [
        // { field: 'id', headerName: 'ID', width: 50, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'codigo', headerName: 'Codigo', width: 80, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/invoiceItem/edit/' + cellValues.row.id} style={{ color: 'inherit' }}>{cellValues.row.codigo}</Link>;
            }
        },
        { field: 'codigoFilial', headerName: 'Filial', width: 80, sortable: false, headerAlign: 'center'},
        { field: 'tipo', headerName: 'Tipo', width: 100, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'sesionesMes', headerName: 'Sesiones Mes', width: 120, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'minutosSesion', headerName: 'Minutos Sesion', width: 120, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'anular', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                return <IconButton aria-label="anular" size='small' style={{height: 10}} align={"center"} disabled={isReadOnly} onClick={() => {
                    setSelectId(cellValues.row.id);
                    setSelectState(cellValues.row.estado);
                    setOpenDialogAnnulActive(true);
                }}>
                    { cellValues.row.estado == "A" ? <IconIndeterminateCheckBox /> : <IconCheckBox /> }
                </IconButton>;
            }
        },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Conceptos de Cobro
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item>
                        <Grid container item xs={12} sm={12} spacing={1}>
                            <Grid item xs={6} sm={3}>
                                <FormControl required fullWidth>
                                    <InputLabel htmlFor="input-servicio">Servicio</InputLabel>
                                    <Select
                                        native
                                        label="Servicio"
                                        value={filters.idServicio}
                                        onChange={(event, newValue) => {
                                            dispatch(setData({name: "idServicio", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idServicio',
                                            id: 'input-servicio',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listServicios.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <FormControl required fullWidth>
                                    <InputLabel htmlFor="input-filial">Filial</InputLabel>
                                    <Select
                                        native
                                        label="Filial"
                                        value={filters.idFilial}
                                        onChange={(event, newValue) => {
                                            dispatch(setData({name: "idFilial", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idFilial',
                                            id: 'input-filial',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listFiliales.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <FormControl required fullWidth>
                                    <InputLabel htmlFor="input-tipo">Tipo</InputLabel>
                                    <Select
                                        native
                                        label="Tipo"
                                        value={filters.idTipo}
                                        onChange={(event, newValue) => {
                                            dispatch(setData({name: "idTipo", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idTipo',
                                            id: 'input-tipo',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listTipos.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <TextField
                                    name="sesionesMes"
                                    label="Sesiones Mes"
                                    value={filters.sesionesMes}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setData({name: "sesionesMes", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estado">Estado</InputLabel>
                                    <Select
                                        native
                                        label="Estado"
                                        value={filters.idEstado}
                                        onChange={(event) => {
                                            dispatch(setData({name: "idEstado", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idEstado',
                                            id: 'input-estado',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listEstados.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} sm={1} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" fullWidth size="medium" onClick={() => {
                                    fetchResults()
                                }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                disabled={isReadOnly}
                                toolbarButtons={[
                                    {
                                        text: "Nuevo",
                                        icon: <IconPersonAdd />,
                                        onClick: () => navigate("/invoiceItem/edit/0")
                                    }
                                ]}
                                // onNewClick={() => navigate(`/invoiceItem/edit/0`)}
                            />
                        </Box>
                    </Grid>
                    <DialogYesNo open={openDialogAnnulActive} openClose={openCloseDialogAnnulActive} setYes={ selectState == "A" ? annul : active}
                        setNo={() => { return }}
                        titulo={(selectState == "A" ? "Anular" : "Activar") + " Concepto de Cobro"}
                        texto={"Esta seguro de " + (selectState == "A" ? "anular" : "activar") + " el concepto de cobro?"} >
                    </DialogYesNo>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index
